import * as React from "react";
type Props = {
  className?: string,
};
function SvgVerified({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-verified"
      className={className}
    >
      <path
        d="M6 12C6.82071 12 7.59345 11.8426 8.31833 11.528C9.04313 11.2173 9.6798 10.7856 10.2282 10.2331C10.7804 9.68055 11.2138 9.04365 11.5282 8.3223C11.8427 7.59713 12 6.82206 12 5.99712C12 5.17602 11.8427 4.4048 11.5282 3.68345C11.2138 2.95827 10.7804 2.31943 10.2282 1.76691C9.6798 1.21439 9.04125 0.78273 8.31255 0.471945C7.58775 0.157314 6.81496 0 5.99425 0C5.17354 0 4.40077 0.157314 3.67594 0.471945C2.9511 0.78273 2.31256 1.21439 1.76031 1.76691C1.21189 2.31943 0.780443 2.95827 0.465964 3.68345C0.155321 4.4048 0 5.17602 0 5.99712C0 6.82206 0.155321 7.59713 0.465964 8.3223C0.780443 9.04365 1.21381 9.68055 1.76606 10.2331C2.31831 10.7856 2.95685 11.2173 3.68169 11.528C4.40652 11.8426 5.17929 12 6 12ZM5.36146 8.8518C5.24257 8.8518 5.13519 8.82683 5.03931 8.77695C4.94343 8.72325 4.85331 8.6427 4.76894 8.53522L3.38255 6.86619C3.32886 6.79328 3.28667 6.7223 3.25599 6.65324C3.22915 6.58034 3.21572 6.50551 3.21572 6.42877C3.21572 6.26762 3.27133 6.13142 3.38255 6.02015C3.49377 5.90504 3.62992 5.84748 3.79099 5.84748C3.88687 5.84748 3.97315 5.86859 4.04986 5.91079C4.12656 5.94916 4.20326 6.01631 4.27997 6.11223L5.3442 7.4475L7.66252 3.74101C7.8006 3.5223 7.97122 3.41295 8.17447 3.41295C8.32792 3.41295 8.46405 3.46283 8.58292 3.56259C8.70562 3.66235 8.76705 3.7928 8.76705 3.95396C8.76705 4.02685 8.75168 4.09976 8.721 4.17266C8.69415 4.24556 8.65965 4.31463 8.61742 4.37986L5.93097 8.53522C5.86194 8.63497 5.77757 8.71365 5.67785 8.77125C5.58197 8.82495 5.47651 8.8518 5.36146 8.8518Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgVerified;
